// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3K_Cz","approved":"Status_approved__2bUzO","rejected":"Status_rejected__3zfT6","expired":"Status_expired__3pisZ","label":"Status_label__38-mM"};